import { getNoticias, getVideos } from "../../../services/meuImovel";

async function verificaSeNoticiaExiste(empreendimentoId, noticiaId) {
  let tempNoticias = [];

  tempNoticias = await getNoticias(empreendimentoId);

  let result = tempNoticias?.filter((noticia) => noticia.Id == noticiaId);
  return result;
}

async function verificaSeVideoExiste(empreendimentoId, videoId) {
  let tempVideos = [];

  tempVideos = await getVideos(empreendimentoId);

  let result = tempVideos?.filter((video) => video.Id == videoId);
  return result;
}

export { verificaSeNoticiaExiste, verificaSeVideoExiste };
